// Dubai is UTC+4 (no DST). A promo expires at the end of its Valid Until day.
export const dubaiToday = () => new Date(Date.now() + 4 * 3600 * 1000).toISOString().slice(0, 10);
export const isPromoExpired = (p) => !!p?.validUntil && p.validUntil.slice(0, 10) < dubaiToday();
